import { RigCostTypeBase } from './base/rig-cost-type-base';

export class RigCostType extends RigCostTypeBase { }